import React from 'react';

import Typography, { TypographyProps } from '@mui/material/Typography';

import { KnzComponentProps } from '../../types';

/** 許可する MUI Typography variant */
const ALLOWED_VARIANTS: TypographyProps['variant'][] = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'subtitle1',
  'subtitle2',
  'body1',
  'body2',
  'caption',
  'overline',
];

/**
 * 地の文（段落）。MUI Typography の variant で文字サイズ・書体を、color で文字色を変えられる。
 * params:
 *   - text（joined）
 *   - variant（任意, MUI Typography variant。デフォルト body2）
 *   - color（任意, テーマトークン or カラーコード。デフォルト text.secondary）
 */
export const Text: React.FC<KnzComponentProps> = ({ node, renderInline }) => {
  const text = (node.params.text as string) ?? '';

  const variantParam = node.params.variant as TypographyProps['variant'] | undefined;
  const variant = variantParam && ALLOWED_VARIANTS.includes(variantParam) ? variantParam : 'body2';

  const color = (node.params.color as string) || 'text.secondary';
  // デフォルトで段落の先頭を字下げする（indent:false で無効化）
  const noIndent = (node.params.indent as string) === 'false';

  return (
    <Typography
      variant={variant}
      color={color}
      component="div"
      sx={{
        lineHeight: 1.9,
        textIndent: noIndent ? 0 : '1em',
        // 中身の Markdown（wmde-markdown）にも variant のサイズ・color を継承させる。
        // これがないと Markdown 側の固定スタイルが優先され、variant/color が効かない。
        // fontWeight は継承しない（**太字** などの Markdown 装飾を残すため）。
        '& .wmde-markdown, & .wmde-markdown p, & .wmde-markdown span, & .wmde-markdown li': {
          fontSize: 'inherit',
          color: 'inherit',
          background: 'transparent',
        },
      }}
    >
      {renderInline(text)}
    </Typography>
  );
};

export default Text;
